module.exports = __webpack_public_path__ + "static/Fireplace-d35e2197c63398fb0aa0fd73df460bbf.png";